import React, { Dispatch, SetStateAction, useEffect, useState } from "react";
import { Dropdown, Layout } from "antd";
import Avatar from "../../../assets/images/user.png";
import { DownOutlined } from "@ant-design/icons";
import  ProfileIcon from "../../../assets/images/icon/user.svg?react";
import  LogoutIcon from "../../../assets/images/icon/logout.svg?react";

import { Link } from "react-router-dom";
import { useAppSelector } from "../../../utils/hooks/hooks";
import LogoutModal from "../../../components/Modals/LogoutModal ";

interface HeaderViewProps {
  collapsed: boolean;
  SetCollapsed: Dispatch<SetStateAction<boolean>>;
}

/**
 * Renders the header view component for the main layout containing dropdown menu for the user profile
 * and a logout button and a button to toggle the sidebar.
 *
 * @param {HeaderViewProps} props - The props for the component.
 * @param {boolean} props.collapsed - Indicates whether the sidebar is collapsed.
 * @param {Dispatch<SetStateAction<boolean>>} props.SetCollapsed - The function to set the collapsed state.
 * @return {ReactElement} The rendered header view component.
 */
const HeaderView: React.FC<HeaderViewProps> = ({ collapsed, SetCollapsed }) => {
  const userDetail = useAppSelector(state => state.auth.userDetail);
  const [logOutModal, setLogOutModal] = useState<boolean>(false);

  const fullUserName = userDetail &&
    (userDetail.name ? userDetail.name : "") +
    " " +
    (userDetail?.last_name ? userDetail.last_name : "");

  const items = [
    {
      label: (
        <Link to="/profile">
          <ProfileIcon />
          <span>Profile</span>
        </Link>
      ),
      key: "profile",
    },
    {
      label: (
        <div onClick={() => { setLogOutModal(true) }}>
          <LogoutIcon />
          <span>Logout</span>
        </div>
      ),
      key: "Logout",
    },
  ];

  useEffect(() => {
    //
  }, [userDetail]);

  return (
    <>
      <Layout.Header className="main__page__appheader">
        <div className="headerWrap">
          <div className="appheader__left">
            <div className="menuToggle">
              <div
                className={`${collapsed ? "icon right" : "icon"}`}
                onClick={() => SetCollapsed(!collapsed)}
              >
                <span></span>
                <span></span>
                <span></span>
              </div>
            </div>
          </div>
          <div className="appheader__right">
            <div className="userDropdown">
              <Dropdown
                menu={{ items }}
                trigger={["click"]}
                overlayClassName="userMenuList"
              >
                <div className="userMenuWrap">
                  <span className="avatar">
                    <img src={Avatar} alt="Avatar" />
                  </span>
                  <span className="userName">
                    {fullUserName}
                  </span>
                  <DownOutlined />
                </div>
              </Dropdown>
            </div>
          </div>
        </div>
      </Layout.Header>
      <LogoutModal open={logOutModal} close={() => { setLogOutModal(false) }} />
    </>
  );
};

export default HeaderView;
